import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SifContextService {
  private isSifSubject = new BehaviorSubject<boolean>(false);
  public isSif$: Observable<boolean> = this.isSifSubject.asObservable();

  constructor(private router: Router) {
    // Initial detection using window.location (more reliable at startup)
    this.detectSifContext(window.location.pathname + window.location.search);
    
    // Listen to route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.detectSifContext(event.url);
      });
  }

  private detectSifContext(url: string): void {
    // Check if URL contains /sapphiresif or has ?sif=1 query param
    const isSif = url.includes('/sapphiresif') || url.includes('?sif=1') || url.includes('&sif=1');
    this.isSifSubject.next(isSif);
  }

  public isSifContext(): boolean {
    return this.isSifSubject.value;
  }

  /**
   * Get search filters based on context
   * MF: [] (empty array)
   * SIF: ["SIF-"]
   */
  public getSearchFilters(): string {
    return this.isSifContext() ? '["SIF-"]' : '[]';
  }

  /**
   * Get search exclude parameter based on context
   * MF: "sibi-filling,SIF-"
   * SIF: "sebi-filling"
   */
  public getSearchExclude(): string {
    return this.isSifContext() ? 'sebi-filling' : 'sibi-filling,SIF-';
  }
}
